// extracted by css-extract-rspack-plugin
export default {"cls1":"VideoResults-cls1_WEh","cls2":"VideoResults-cls2_3yr VideoResults-cls1_WEh"};